// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__gqid8","rotation":"Loader_rotation__36e2a"};